import {RecordingInfoPanel} from "@/shared/recording/recordingInfoPanel";
import {Car} from "@/shared/timr";

export class DriveLogInfoPanel extends RecordingInfoPanel {

	public update(car: Car) {
		// Nothing to show yet
		this.onVisibilityChanged();
	}

	public isVisible(): boolean {
		return this.infoPanel.find(".driveLogTipField").css("display") === "block";
	}
}
